import { configureStore } from "@reduxjs/toolkit";
import AuthReducer from "./redux/AuthReducer/AuthSlice";
import AuthCardReducer from "./redux/AuthCardReducer/AuthCardSlice";
import TermDataReducer from "./redux/TermDataReducer/TermDataSlice";
import EmployeeReducer from "./redux/EmployeeReducer/EmployeeSlice";
import RewardsReducer from "./redux/RewardReducer/RewardsSlice";
import AcademicYearReducer from "./redux/AcademicYearReducer/AcademicYearSlice";
import StudentsReducer from "./redux/super_admin/studentsReducer/StudentsSlice";
import PlCEventReducer from "./redux/plc/EventsReducer/EventsSlice";
import PlcReportsReducer from "./redux/plc/ReportsReducer/ReportsSlice";
import dtsEventCategory from "./redux/DTS/EventCategoryReducer/EventCategorySlice";
import MasterSliceReducer from "./redux/tft/Master/MasterSlice";
import TftReportSliceReducer from "./redux/tft/Reports/ReportSlice";

const store = configureStore({
  reducer: {
    Auth: AuthReducer,
    AuthCard: AuthCardReducer,
    TermData: TermDataReducer,
    Employee: EmployeeReducer,
    Rewards: RewardsReducer,
    AcademicYear: AcademicYearReducer,
    Students: StudentsReducer,
    PLCEvents: PlCEventReducer,
    PlcReports: PlcReportsReducer,
    dtsEventCategory: dtsEventCategory,
    MasterSliceReducer: MasterSliceReducer,
    TftReport: TftReportSliceReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
